export default __webpack_public_path__ + "static/media/lesson3.80c0672d.svg";